import {createContext} from "react";

const GPTBillContext = createContext();

export default GPTBillContext;